export const person = (state) => {
  if (state.proxyPerson) {
    state.proxyPerson.personOfInterest = Number(state.proxyPerson.personOfInterest)
    return state.proxyPerson
  } else {
    return state.primaryPerson
  }
}
export const primaryPerson = (state) => state.primaryPerson
export const proxyPerson = (state) => state.proxyPerson
export const settings = (state) => state.settings
export const searchResults = (state) => state.searchResults
export const authenticated = (state) => Boolean(state.primaryPerson)
export const personGroups = (state) => state.personGroups
export const baxterBucks = (state) => {
  if (state.proxyPerson) {
    return state.proxyPerson.baxterBucks
  } else {
    return state.primaryPerson.baxterBucks
  }
}
export const timeout = (state) => state.timeout
